<section
  class="atw-page change-password-page"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="atw-container">
    <div class="section-title">
      <span>
        <b>{{ 'changePassword.sectionNumber' | transloco }}</b>
      </span>

      <div>
        <h2>{{ 'changePassword.title' | transloco }}</h2>
        <p>{{ 'changePassword.subtitle' | transloco }}</p>
      </div>
    </div>

    <div class="change-password-card apply-card">
      <div class="change-password-visual">
        <div class="password-icon">
          <img class="img-l" src="assets/as/22.webp" alt="password" />
        </div>

        <h1>{{ 'changePassword.cardTitle' | transloco }}</h1>
        <p>{{ 'changePassword.cardText' | transloco }}</p>
      </div>

      <form
        class="change-password-form"
        [formGroup]="passwordForm"
        (ngSubmit)="onSubmit()"
      >
        <div class="password-field">
          <label>{{ 'changePassword.oldPassword' | transloco }}</label>

          <div class="password-input">
            <input
              [type]="showOldPassword ? 'text' : 'password'"
              formControlName="old_password"
              [placeholder]="'changePassword.oldPasswordPlaceholder' | transloco"
              autocomplete="current-password"
              [class.invalid]="isInvalid('old_password')"
            />

            <button type="button" (click)="togglePassword('old')">
              {{
                showOldPassword
                  ? ('changePassword.hide' | transloco)
                  : ('changePassword.show' | transloco)
              }}
            </button>
          </div>

          <small *ngIf="isInvalid('old_password')">
            {{ 'changePassword.validation.oldRequired' | transloco }}
          </small>
        </div>

        <div class="password-field">
          <label>{{ 'changePassword.newPassword' | transloco }}</label>

          <div class="password-input">
            <input
              [type]="showNewPassword ? 'text' : 'password'"
              formControlName="new_password"
              [placeholder]="'changePassword.newPasswordPlaceholder' | transloco"
              autocomplete="new-password"
              [class.invalid]="isInvalid('new_password') || hasFormError('passwordSameAsOld')"
            />

            <button type="button" (click)="togglePassword('new')">
              {{
                showNewPassword
                  ? ('changePassword.hide' | transloco)
                  : ('changePassword.show' | transloco)
              }}
            </button>
          </div>

          <small *ngIf="isInvalid('new_password')">
            {{ 'changePassword.validation.newRequired' | transloco }}
          </small>

          <small *ngIf="hasFormError('passwordSameAsOld')">
            {{ 'changePassword.validation.sameAsOld' | transloco }}
          </small>
        </div>

        <div class="password-field">
          <label>{{ 'changePassword.confirmPassword' | transloco }}</label>

          <div class="password-input">
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              formControlName="new_password_confirmation"
              [placeholder]="'changePassword.confirmPasswordPlaceholder' | transloco"
              autocomplete="new-password"
              [class.invalid]="isInvalid('new_password_confirmation') || hasFormError('passwordMismatch')"
            />

            <button type="button" (click)="togglePassword('confirm')">
              {{
                showConfirmPassword
                  ? ('changePassword.hide' | transloco)
                  : ('changePassword.show' | transloco)
              }}
            </button>
          </div>

          <small *ngIf="isInvalid('new_password_confirmation')">
            {{ 'changePassword.validation.confirmRequired' | transloco }}
          </small>

          <small *ngIf="hasFormError('passwordMismatch')">
            {{ 'changePassword.validation.passwordMismatch' | transloco }}
          </small>
        </div>

        <div class="change-password-actions">
          <a class="secondary-action" routerLink="/profile">
            {{ 'changePassword.cancel' | transloco }}
          </a>

          <button class="primary-action" type="submit" [disabled]="isSaving">
            {{
              isSaving
                ? ('changePassword.saving' | transloco)
                : ('changePassword.save' | transloco)
            }}
          </button>
        </div>
      </form>
    </div>
  </div>
</section>
